/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const GradingIcon = /*#__PURE__*/ createSvgIcon(
  'GradingIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M13.458 14.875l1.959-1.958a.729.729 0 011.062 0 .729.729 0 010 1.062l-2.493 2.494a.733.733 0 01-.531.235.698.698 0 01-.518-.229l-1.083-1.083a.693.693 0 01-.219-.531.769.769 0 01.24-.532.73.73 0 011.063 0l.52.542zM3.75 17a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h5.5c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535A.72.72 0 019.25 17h-5.5zm0-3.125a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h5.5c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219h-5.5zm0-3.125a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h12.5c.212 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H3.75zm0-3.125a.728.728 0 01-.534-.214A.72.72 0 013 6.879c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h12.5c.212 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H3.75zm0-3.125a.728.728 0 01-.534-.214A.72.72 0 013 3.754c0-.21.072-.39.216-.535A.72.72 0 013.75 3h12.5c.212 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H3.75z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default GradingIcon;
